var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CAEFF7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EDFAFC",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 37V35C36.5 33.9391 36.0786 32.9217 35.3284 32.1716C34.5783 31.4214 33.5609 31 32.5 31H24.5C23.4391 31 22.4217 31.4214 21.6716 32.1716C20.9214 32.9217 20.5 33.9391 20.5 35V37M32.5 23C32.5 25.2091 30.7091 27 28.5 27C26.2909 27 24.5 25.2091 24.5 23C24.5 20.7909 26.2909 19 28.5 19C30.7091 19 32.5 20.7909 32.5 23Z",
    stroke: "#20B3D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBig);
export default __webpack_public_path__ + "static/media/userBig.97f7cf686c5f2eaaf85505de65a48abb.svg";
export { ForwardRef as ReactComponent };